window.addEventListener('load', () => {
    function waitForBundlingSku(retries = 10) {
        let bundlingSku = window.location.search.substring(1);  
        if (!bundlingSku) {
            bundlingSku = sessionStorage.getItem("bundlingsku");
        }
        if (bundlingSku) {
            fetchProducts(bundlingSku);
        }
        else if (retries > 0) {
            setTimeout(() => waitForBundlingSku(retries - 1), 300); // Retry every 300ms
        } else {
            console.error("Error: bundlingSku is not set in sessionStorage.");
        }
    }

    function createTabHeading(productName, productCount, index) {
        const heading = document.createElement('p');
        heading.classList.add('tab-heading');
        heading.setAttribute('data-category', `category-${index}`);
        heading.innerHTML = `${productName} (${productCount})`;
        return heading;
    }

    function createProductContainer(index, productArray) {
        const productContainer = document.createElement('div');
        productContainer.classList.add('product-category');
        productContainer.setAttribute('data-match', `category-${index}`);
        productArray.forEach(item => {
            const productCard = createProductCard(item);
            setTimeout(() => {
                document.querySelector('.bundling-tab-shimmer').style.display = 'none';
                productContainer.appendChild(productCard);
                checkVisibilityAndCallAPI();
            }, 1000);
        });
        return productContainer;
    }

    function createProductCard(item) {
        const productCard = document.createElement('div');        
        productCard.classList.add('bundling-product-card');
        productCard.setAttribute('data-prd-title', item.name);
        productCard.setAttribute('data-prd-price', `₹ ${item.sellingPrice}`);
        productCard.setAttribute('data-prd-id', item.groupId);

        let itemPercentage = ((item.price - item.sellingPrice) / item.price) * 100;
        itemPercentage = itemPercentage % 1 === 0 ? `${itemPercentage.toFixed(0)}%` : `${itemPercentage.toFixed(2)}%`;

        productCard.innerHTML = `
        <a href="/products/${item.handle}">
            <img src="${item.image}" alt="${item.name}" class="bundling-product-image">
            <div class="bundling-product-details">
                <div class="CT-product-link product-link ct_product-block__title">${item.name}</div>
                ${item.sellingPrice !== item.price
                    ? `
                    <div class="ct_rec_price-item">
                        <div class="price-item price-item--regular">
                            <span class="ct_compare_price">₹${Number(item.sellingPrice).toLocaleString("en-IN")}</span>
                        </div>
                        <span class="product-price__item CT-product-price__compare product-price__compare theme-money">
                            ₹${Number(item.price).toLocaleString("en-IN")}
                        </span>
                        <div class="CT_parsent_off_">
                            ${itemPercentage} OFF
                        </div>
                    </div>`
                    : `
                    <div class="CT_product-price__item product-price__item product-price__amount theme-money">
                        ₹${item.sellingPrice}
                    </div>`
                }
            </div>
            </a>
            <div class="ct_hart_icon_main">
                <div class="ct_hart_icon ct_hart_icon-media">
                    <div class="wishlist_img_main" data-prod-sku="${item.sku}" data-prod-id="${item.groupId}" data-prod-type="Temple Finger Ring" data-prod-metafiled-type="${item.category}" data-prod-title="${item.name}" data-prod-featured-image="${item.image}" data-prod-variant-id="${item.id}" data-prod-price="${item.sellingPrice}" data-prod-selling-price="${item.price}">
                    <img class="wish_uncheck wishlist_blank_icon" width="30" height="30" src="https://cdn.shopify.com/s/files/1/0796/1959/files/wish_uncheck.webp?v=1734585398" loading="lazy">
                    <img class="wish_fill wishlist_fill_icon" width="30" height="30" src="https://cdn.shopify.com/s/files/1/0796/1959/files/wish_fill.png" loading="lazy">
                    </div>
                </div>
                <div class="wish_added" style="display: none;">
                    <h2>Added To Wishlist</h2>
                </div>
                <div class="rb_wish_remove" style="display: none;">
                    <h2>Removed From Wishlist</h2>
                </div>
            </div>
        `;
        return productCard;
    }

    function setActiveTab(productContainer, heading) {
        productContainer.classList.add('active');
        document.querySelectorAll('.tab-heading').forEach(heading => heading.classList.remove('active'));
        heading.classList.add('active');
        heading.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }

    function addTabSwitchingEventListeners() {
        document.querySelectorAll('.tab-heading').forEach(tab => {
            tab.addEventListener('click', function () {
                const category = this.getAttribute('data-category');
                clevertap.event.push("Category_click", {
                    "Category name": this.textContent.trim().replace(/\s*\(\d+\)$/, ''),
                    "No. of products": this.textContent.match(/\((\d+)\)/)?.[1] || null,
                });

                document.querySelectorAll('.product-category').forEach(container => {
                    container.classList.remove('active');
                    container.style.display = 'none';
                });

                const selectedCategory = document.querySelector(`.product-category[data-match="${category}"]`);
                selectedCategory.style.display = 'flex';
                selectedCategory.classList.add('active');

                document.querySelectorAll('.tab-heading').forEach(heading => heading.classList.remove('active'));
                this.classList.add('active');
                this.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
            });
        });
    }

    async function fetchProducts(bundlingSku) {
        try {
            const response = await fetch(`https://middleware.technoboost.in/api/v1/callback/products-type-wise?sku=${bundlingSku}`);
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

            const data = await response.json();
            document.querySelector('.bundling-shimmer-box').style.display = 'none';

            const bundlingHeading = document.querySelector('.bundling-tab-title');
            const bundlingContent = document.querySelector('.bundling-tab-content');
            let isSessionStorage = false;
            let firstTab = true;

            Object.entries(data.product).forEach(([productName, productArray], index) => {
                const productCount = productArray.length;
                const heading = createTabHeading(productName, productCount, index);
                const productContainer = createProductContainer(index, productArray);

                let storedCategory = sessionStorage.getItem(`selectedCategory_${bundlingSku}`);
                if (storedCategory === `category-${index}`) {
                    isSessionStorage = true;
                    setActiveTab(productContainer, heading);
                } else if (firstTab && !storedCategory) {
                    productContainer.classList.add('active');
                } else {
                    productContainer.style.display = 'none';
                }

                bundlingHeading.appendChild(heading);
                bundlingContent.appendChild(productContainer);
                firstTab = false;
            });

            addTabSwitchingEventListeners();
            if (!isSessionStorage) {
                document.querySelector('.tab-heading').classList.add('active');
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    }

    waitForBundlingSku();
});

function updateCartElements(cart) {
    const productCount = document.querySelector('.bundling-cart-text-title');
    const imageContainer = document.querySelector('.bundling-image-container');
    const cartBundlePrice = document.querySelector('.cart-bundle-price');

    if (!productCount || !imageContainer || !cartBundlePrice) return;

    // Clear existing bundling images
    document.querySelectorAll('.bundling-image').forEach(el => el.remove());

    const parser = new DOMParser();
    const doc = parser.parseFromString(cart, "text/html");

    const cartItemCount = parseInt(
        doc.querySelector('.majortitle span')?.innerText.replace(/[()]/g, '') || '0', 10
    );

    const cartImages = Array.from(doc.querySelectorAll('.mm-ajaxcart-item-image img')).slice(0, 3).reverse();
    const cartProductName = doc.querySelector('.mm-ajaxcart-item-name a')?.textContent.trim() || 'Product';

    // Image handling using document fragment
    if (cartImages.length) {
        const fragment = document.createDocumentFragment();
        cartImages.forEach(img => {
            const bundlingDiv = document.createElement('div');
            bundlingDiv.classList.add('bundling-image');

            const newImg = document.createElement('img');
            newImg.src = img.src;
            newImg.alt = 'Product Image';
            newImg.width = 100;
            newImg.height = 100;

            bundlingDiv.appendChild(newImg);
            fragment.appendChild(bundlingDiv);
        });
        imageContainer.prepend(fragment);
    }

    // Ensure 'bundle-cart-check' exists
    let svgCheckElement = imageContainer.querySelector('.bundle-cart-check');
    if (!svgCheckElement) {
        svgCheckElement = document.createElement('span');
        svgCheckElement.classList.add('bundle-cart-check');
        svgCheckElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <circle cx="16.0001" cy="16.0005" r="11.4286" fill="white"/>
                <path d="M16 0C20.2435 0 24.3131 1.68571 27.3137 4.68629C30.3143 7.68687 32 11.7565 32 16C32 20.2435 30.3143 24.3131 27.3137 27.3137C24.3131 30.3143 20.2435 32 16 32C11.7565 32 7.68687 30.3143 4.68629 27.3137C1.68571 24.3131 0 20.2435 0 16C0 11.7565 1.68571 7.68687 4.68629 4.68629C7.68687 1.68571 11.7565 0 16 0ZM14.0069 19.1566L10.4526 15.6C10.3252 15.4726 10.1739 15.3715 10.0074 15.3025C9.84092 15.2336 9.66249 15.1981 9.48229 15.1981C9.30209 15.1981 9.12365 15.2336 8.95717 15.3025C8.79069 15.3715 8.63942 15.4726 8.512 15.6C8.25466 15.8573 8.1101 16.2064 8.1101 16.5703C8.1101 16.9342 8.25466 17.2832 8.512 17.5406L13.0377 22.0663C13.1648 22.1943 13.3159 22.296 13.4825 22.3653C13.649 22.4347 13.8276 22.4704 14.008 22.4704C14.1884 22.4704 14.367 22.4347 14.5335 22.3653C14.7001 22.296 14.8512 22.1943 14.9783 22.0663L24.3497 12.6926C24.4788 12.5657 24.5816 12.4145 24.652 12.2477C24.7223 12.0809 24.759 11.9018 24.7599 11.7208C24.7607 11.5398 24.7257 11.3603 24.6569 11.1929C24.588 11.0255 24.4867 10.8733 24.3588 10.7452C24.2308 10.6172 24.0788 10.5157 23.9114 10.4466C23.7441 10.3776 23.5647 10.3424 23.3837 10.343C23.2027 10.3436 23.0235 10.3801 22.8567 10.4503C22.6898 10.5205 22.5385 10.623 22.4114 10.752L14.0069 19.1566Z" fill="#28BE7F"/>
            </svg>`;
        imageContainer.appendChild(svgCheckElement);
    }

    // Update product count text
    productCount.innerHTML = cartItemCount > 1 ? `${cartItemCount} Items In Cart` : cartProductName;

    // Update price
    const totalPrice = parseInt(doc.querySelector(".theme-money-price")?.getAttribute("data-price") || "0", 10);
    cartBundlePrice.innerHTML = `₹ ${totalPrice.toLocaleString("en-IN")}`;
}

function cartOpen() {
    mmajaxcart.AjaxcartOpen();
}

document.querySelector('.bundling-tab-content').addEventListener('click', (event) => {
    const prdt = event.target.closest('.bundling-product-card');
    if (prdt) {
        const prdTitle = prdt.getAttribute("data-prd-title");
        const prdPrice = prdt.getAttribute("data-prd-price");
        const prdId = prdt.getAttribute("data-prd-id");
        console.log('Product clicked:', prdt, prdTitle, prdPrice, prdId);
        clevertap.event.push("Product_Click", {
            "Product Name": prdTitle,
            "Product Price": prdPrice,
            "Product ID": prdId,
        });
    }
});

const bundlingGoBack = () => {
    if (document.referrer) {
        window.history.back();
    } else {
        window.location.href = '/';
    }
};
